export default {
  submit: "Absenden",
  search: "Suchen",
  reset: "Zurücksetzen",
  select: "Auswählen",
  create: "Erstellen",
  update: "Aktualisieren",
  edit: "Bearbeiten",
  delete: "Löschen",
  add: "Hinzufügen",
  remove: "Entfernen",
  cancel: "Abbrechen",
  save: "Speichern",
  saved: "Gespeichert",
  loading: "Wird geladen...",
  error: "Fehler",
  success: "Erfolg",
  warning: "Warnung",
  info: "Information",
  date: "Datum",
  time: "Zeit",
  today: "Heute",
  yesterday: "Gestern",
  tomorrow: "Morgen",
  lastDays: "Letzte {days} Tage",
  upgrade: "Upgrade",
  import: "Importieren",
  export: "Exportieren",
  ok: "OK",
  close: "Schließen",
  clear: "Löschen",
  retry: "Erneut versuchen",
  upload: "Hochladen",
  row: "Zeile {row}",
  items: "Elemente",
  yes: "Ja",
  no: "Nein",
  utc: "UTC",
  london: "London",
  paris: "Paris",
  berlin: "Berlin",
  shanghai: "Shanghai",
  new_york: "New York",
  los_angeles: "Los Angeles",
  privacy_policy: "Datenschutzrichtlinie anzeigen",
  email_placeholder: "Bitte geben Sie Ihre E-Mail-Adresse ein",
  empty_chart_action: "Jetzt berechnen",
  preview: "Vorschau",
  sign_out: "Abmelden",
  invoice: "Rechnung",
  credit_notes: "Gutschriften",
  filter: "Filter",
  trendChart: {
    export_image: "Bild exportieren",
    this_month: "Dieser Monat",
    last_month: "Letzter Monat",
    month_before_last: "Vormonat",
    this_week: "Diese Woche",
    last_2_weeks: "Letzte 2 Wochen",
    last_4_weeks: "Letzte 4 Wochen",
    today: "Heute",
    yesterday: "Gestern",
    day_before_yesterday: "Vorgestern",
    month: "Monat",
    week: "Woche",
    day: "Tag",
    export_failed: "Diagramm konnte nicht exportiert werden",
    export_retry: "Diagrammexport fehlgeschlagen, bitte erneut versuchen",
  },
  view_all_news: "Alle Nachrichten anzeigen",
  confirm: "Bestätigen",
  rangeSearch: "Bereichssuche",
  leg: {
    origin: "Herkunft",
    destination: "Ziel",
    transportMode: "Transportmodus",
    distance: "Strecke (km)",
    weight: "Gewicht (t)",
    cnCode: "KN-Code",
    transportEmission: "Transport-Emission (kg CO2e)",
    productionEmission: "Produktions-Emission (kg CO2e)",
    totalEmission: "Gesamt-Emission (kg CO2e)",
  },
  previewReports: {
    pdfPreview: "PDF-Vorschau",
    excelPreview: "Excel-Vorschau",
    payPerUse: "Limit überschritten, nutzungsbasierte Bezahlung?",
    payPerUseDownload: "Nutzungsbasierter Download",
    download: "Herunterladen",
    refresh: "Aktualisieren",
    darkModeWarning:
      "Der Dunkelmodus dient nur der Vorschau der Benutzeroberfläche und beeinflusst nicht exportierte Dateien. Exportierte Dateien behalten einen weißen Hintergrundstil bei",
    upgradeToUnlockExcel: "Upgraden Sie auf Pro, um die Excel-Vorschau freizuschalten",
    unlockFeatures:
      "Schalten Sie Excel-Export, benutzerdefiniertes Logo, Mehrsprachigkeit und andere erweiterte Funktionen frei, um die Professionalität von Berichten zu verbessern!",
    upgradeNow: "Jetzt upgraden",
    previewFailed: "Vorschau fehlgeschlagen",
    excelPreviewRequiresPro: "Excel-Vorschau erfordert ein Pro-Abonnement!",
    limitReached: "Tägliches oder monatliches Limit erreicht",
    saved: "Erfolgreich gespeichert, Sie können es in der Berichtsliste anzeigen",
  },
  select_status: "Status auswählen",
  select_plan_type: "Plantyp auswählen",
  refund: "Rückerstattung",
  view: "Ansehen",
  start_date: "Startdatum",
  end_date: "Enddatum",
  view_details: "Details anzeigen",
  back_to_login: "Zurück zur Anmeldung",
  view_count_description:
    "Die Ansichtszahl stellt die Gesamtanzahl der Aufrufe dieses Berichts über die Freigabe dar. Das Aufheben der Freigabe setzt diesen Zähler nicht zurück.",
  notify: {
    auto_renew: "Automatische Verlängerung",
    auto_renew_desc:
      "Aktivieren, um Ihr Abonnement am Ende des Abrechnungszyklus automatisch zu verlängern.",
  },
  ticketTypes: {
    technical: "Technisches Problem",
    billing: "Abrechnungsproblem",
    compliance: "Compliance-Beratung",
    feedback: "Feedback und Vorschläge",
    other: "Andere",
  },
  loading_verification: "Verifizierung wird geladen...",
  billing: {
    current_plan: "Aktueller Plan",
    upgrade: "Upgrade anzeigen",
    manage: "Abrechnung anzeigen",
    plan_type: "Plantyp",
    next_billing: "Nächstes Abrechnungsdatum",
    expiry_date: "Ablaufdatum",
    expired: "Abgelaufen",
    permanent: "Dauerhaft",
  },
  faq: {
    search_placeholder: "FAQs durchsuchen...",
    no_results_title: "Keine Ergebnisse gefunden",
    no_results_subtitle:
      "Versuchen Sie, Ihre Suchbegriffe anzupassen oder durchsuchen Sie die Kategorien auf der linken Seite.",
    search_cleared_message: "Suche gelöscht, um vollständigen Inhalt anzuzeigen",
    still_have_questions: {
      before_email: "Noch Fragen? Kontaktieren Sie uns unter ",
      after_email: " — unser Team antwortet innerhalb von 24 Stunden.",
    },
  },
};
